// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZxJ7","right":"styles_right__1hHa8"};